@let template = item.template;
@let hasMore = tail.length > 0;

@for (row of head; track $index; let isLast = $last) {
  <ng-container
    *ngTemplateOutlet="
      template;
      context: { $implicit: row, index: $index, last: isLast && !(expanded && hasMore) }
    "
  ></ng-container>
}

@if (expanded && hasMore) {
  <div class="show-more-list-extra" [@expandCollapse]>
    @for (row of tail; track $index; let isLast = $last) {
      <ng-container
        *ngTemplateOutlet="
          template;
          context: { $implicit: row, index: limit + $index, last: isLast }
        "
      ></ng-container>
    }
  </div>
}

@if (hasMore) {
  <button type="button" class="show-more-list-toggle" (click)="toggle()">
    @if (expanded) {
      {{ "SHOW_LESS" | translate }}
    } @else {
      {{ "SHOW_MORE" | translate }} ({{ tail.length }})
    }
  </button>
}
